export default __webpack_public_path__ + "static/media/edit_dev.ce919da8.svg";